import { render, staticRenderFns } from "./TasksEdit.vue?vue&type=template&id=08fcc666&"
import script from "./TasksEdit.vue?vue&type=script&lang=js&"
export * from "./TasksEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TasksEdit.vue"
export default component.exports